export const title = 'Booking Requests';

export const STATUS_REQUESTS = [
    {
        id: 'all',
        title: 'All'
    },
    {
        id: 'open',
        title: 'Open'
    },
    {
        id: 'close',
        title: 'Close'
    }
];

export const REQUESTS_TYPE = [
    {
        id: 'allRequests',
        label: 'All Requests'
    },
    {
        id: 'agentRequests',
        label: 'Agent Requests'
    },
    {
        id: 'failed',
        label: 'Failed'
    },
    {
        id: 'pending',
        label: 'Pending'
    },
    {
        id: 'manualRequests',
        label: 'Manual Requests'
    }
];

export const COMMENTS_TYPE = [
    {
        id: 'agentConversations',
        label: 'Agent Conversations',
        value: 0
    },
    {
        id: 'internalConversations',
        label: 'Internal Conversations',
        value: 1
    }
];

export const REQUEST_TABS_INFO = {
    1: [
        {
            id: 21,
            value: 'pending_requests'
        },
        {
            id: 22,
            value: 'failed_requests'
        },
        {
            id: 23,
            value: 'manual_requests'
        }
    ],
    2: [
        {
            id: 22,
            value: 'request_type'
        }
    ],
    3: [
        {
            id: 21,
            value: 'request_type'
        }
    ],
    4: [
        {
            id: 23,
            value: 'request_type'
        }
    ]
};

export const headCells = [
    { id: 'booking_code', numeric: false, disablePadding: false, align: 'left', label: 'Booking Code', showSort: false },
    { id: 'pnr', numeric: false, disablePadding: false, align: 'left', label: 'PNR', showSort: false },
    { id: 'ticket_status', numeric: true, disablePadding: false, align: 'left', label: 'Ticket Status', showSort: false },
    { id: 'request_type', numeric: true, disablePadding: false, align: 'left', label: 'Request Type', showSort: false },
    { id: 'internal_status', numeric: true, disablePadding: false, align: 'left', label: 'Internal Status', showSort: false },
    { id: 'member_remarks', numeric: true, disablePadding: false, align: 'left', label: 'Member Remarks', showSort: false },
    { id: 'booking__departure_at', numeric: false, disablePadding: false, align: 'left', label: 'Date Of Travel', showSort: true },
    {
        id: 'sellerBookingCode',
        numeric: false,
        disablePadding: false,
        align: 'left',
        label: 'Supplier',
        showSort: false
    },
    {
        id: 'assinee',
        numeric: false,
        disablePadding: false,
        align: 'left',
        label: 'Assinee',
        showSort: false
    },
    { id: 'last_comment_by', numeric: false, disablePadding: false, align: 'left', label: 'Last Comment By', showSort: false },
    { id: 'category', numeric: false, disablePadding: false, align: 'left', label: 'Category', showSort: false },
    { id: 'created_at', numeric: false, disablePadding: false, align: 'left', label: 'Created At', showSort: true },
    { id: 'updated_at', numeric: false, disablePadding: false, align: 'left', label: 'Updated At', showSort: true }
];

export const DURATION_FILTER_DROPDOWN_DATA = [
    {
        label: 'Today',
        id: 'today'
    },
    {
        label: 'Yesterday',
        id: 'yesterday'
    },
    {
        label: 'Last 3 days',
        id: 'last_3_days'
    },
    {
        label: 'Last 7 days',
        id: 'last_7_days'
    },
    {
        label: 'Last 15 days',
        id: 'last_15_days'
    },
    {
        label: 'Last 30 days',
        id: 'last_30_days'
    },
    {
        label: 'Last 90 days',
        id: 'last_90_days'
    },
    {
        label: 'Last 120 days',
        id: 'last_120_days'
    }
];

export const DURATION_FILTER_KEYS = {
    today: '0',
    yesterday: '1',
    last_3_days: '2',
    last_7_days: '6',
    last_15_days: '14',
    last_30_days: '29',
    last_90_days: '89',
    last_120_days: '119'
};

export const JOURNEY_TYPES = {
    1: {
        name: 'ONEWAY',
        value: 1,
        label: 'One Way'
    },
    2: {
        name: 'RETURN',
        value: 2,
        label: 'Round Trip'
    },
    3: {
        name: 'MULTICITY',
        value: 3,
        label: 'Multicity'
    }
};

export const DEFAULT_ORDER = 'desc';
export const DEFAULT_ORDER_BY = 'created_at';
export const REQUEST_TYPE_KEY = 'request_type';
export const REQUEST_TYPE_PENDING = 'pending_requests';
export const REQUEST_TYPE_FAILED = 'failed_requests';
export const REQUEST_TYPE_MANUAL = 'manual_requests';
export const FILTER_TYPE_SEARCH = 'search';
export const SERVICE_REQUEST_STATUS = 'service_request_status';
export const CATEGORY_FLIGHTS = 'Flights';
export const CATEGORY_ACCOMODATION = 'Accommodation (Hotel)';
export const CATEGORY_PACKAGES = 'Package';
export const BOOKING_TYPE = 'bookings';
export const PAX_TYPE = 'pax';
export const DEFAULT_ERROR_MESSAGE = 'Something Went Wrong';
export const MODULE_ACCESS_BOOKING_REQUESTS = 'BOOKING_REQUEST';
export const MODULE_ACCESS_BOOKING_REQUESTS_SIDE_NAV = 'BOOKING_REQUEST_SIDE_NAV';
export const VIEW_TYPE_BOOKING_REQUEST_INTERNAL_CONVERSATION = 'booking_request_internal_conversation';
